const DEFAULT_ENABLED_REGIONS = ['us-east-1', 'us-east-2', 'us-west-1', 'us-west-2', 'ca-central-1', 'eu-north-1', 'eu-west-1', 'eu-west-2', 'eu-west-3', 'eu-central-1', 'ap-northeast-1', 'ap-northeast-2', 'ap-southeast-1', 'ap-southeast-2', 'ap-south-1', 'sa-east-1'];

const ENABLED_REGIONS = new Set(process.env.REACT_APP_ENABLED_REGIONS ? 
	process.env.REACT_APP_ENABLED_REGIONS.split(',').map(region => region.trim()) : DEFAULT_ENABLED_REGIONS);

const REGION_LIST = [
	{
		"name": "N. Virginia",
		"full_name": "US East (N. Virginia)",
		"code": "us-east-1",
		"public": true,
		"zones": [
			"us-east-1a",
			"us-east-1b",
			"us-east-1c",
			"us-east-1d",
			"us-east-1e",
			"us-east-1f"
		]
	},
	{
		"name": "Ohio",
		"full_name": "US East (Ohio)",
		"code": "us-east-2",
		"public": true,
		"zones": [
			"us-east-2a",
			"us-east-2b",
			"us-east-2c"
		]
	},
	{
		"name": "N. California",
		"full_name": "US West (N. California)",
		"code": "us-west-1",
		"public": true,
		"zone_limit": 2,
		"zones": [
			"us-west-1a",
			"us-west-1b",
			"us-west-1c"
		]
	},
	{
		"name": "Oregon",
		"full_name": "US West (Oregon)",
		"code": "us-west-2",
		"public": true,
		"zones": [
			"us-west-2a",
			"us-west-2b",
			"us-west-2c",
			"us-west-2d"
		]
	},
	{
		"name": "Canada",
		"full_name": "Canada (Central)",
		"code": "ca-central-1",
		"public": true,
		"zones": [
			"ca-central-1a",
			"ca-central-1b"
		]
	},
	{
		"name": "Stockholm",
		"full_name": "EU (Stockholm)",
		"code": "eu-north-1",
		"public": true,
		"zones": [
			"eu-north-1a",
			"eu-north-1b",
			"eu-north-1c"
		]
	},
	{
		"name": "Ireland",
		"full_name": "EU (Ireland)",
		"code": "eu-west-1",
		"public": true,
		"zones": [
			"eu-west-1a",
			"eu-west-1b",
			"eu-west-1c"
		]
	},
	{
		"name": "London",
		"full_name": "EU (London)",
		"code": "eu-west-2",
		"public": true,
		"zones": [
			"eu-west-2a",
			"eu-west-2b",
			"eu-west-2c"
		]
	},
	{
		"name": "Paris",
		"full_name": "EU (Paris)",
		"code": "eu-west-3",
		"public": true,
		"zones": [
			"eu-west-3a",
			"eu-west-3b",
			"eu-west-3c"
		]
	},
	{
		"name": "Frankfurt",
		"full_name": "EU (Frankfurt)",
		"code": "eu-central-1",
		"public": true,
		"zones": [
			"eu-central-1a",
			"eu-central-1b",
			"eu-central-1c"
		]
	},
	{
		"name": "Tokyo",
		"full_name": "Asia Pacific (Tokyo)",
		"code": "ap-northeast-1",
		"public": true,
		"zone_limit": 3,
		"zones": [
			"ap-northeast-1a",
			"ap-northeast-1b",
			"ap-northeast-1c",
			"ap-northeast-1d"
		]
	},
	{
		"name": "Seoul",
		"full_name": "Asia Pacific (Seoul)",
		"code": "ap-northeast-2",
		"public": true,
		"zones": [
			"ap-northeast-2a",
			"ap-northeast-2b",
			"ap-northeast-2c"
		]
	},
	{
		"name": "Singapore",
		"full_name": "Asia Pacific (Singapore)",
		"code": "ap-southeast-1",
		"public": true,
		"zones": [
			"ap-southeast-1a",
			"ap-southeast-1b",
			"ap-southeast-1c"
		]
	},
	{
		"name": "Sydney",
		"full_name": "Asia Pacific (Sydney)",
		"code": "ap-southeast-2",
		"public": true,
		"zones": [
			"ap-southeast-2a",
			"ap-southeast-2b",
			"ap-southeast-2c"
		]
	},
	{
		"name": "Mumbai",
		"full_name": "Asia Pacific (Mumbai)",
		"code": "ap-south-1",
		"public": true,
		"zones": [
			"ap-south-1a",
			"ap-south-1b",
			"ap-south-1c"
		]
	},
	{
		"name": "São Paulo",
		"full_name": "South America (São Paulo)",
		"code": "sa-east-1",
		"public": true,
		"zone_limit": 2,
		"zones": [
			"sa-east-1a",
			"sa-east-1b",
			"sa-east-1c"
		]
	},
	{
		"name": "GovCloud West",
		"full_name": "AWS GovCloud (US)",
		"code": "us-gov-west-1",
		"public": false,
		"zones": [
			"us-gov-west-1a",
			"us-gov-west-1b",
			"us-gov-west-1c"
		]
	},
	{
		"name": "GovCloud East",
		"full_name": "AWS GovCloud (US-East)",
		"code": "us-gov-east-1",
		"public": false,
		"zones": [
			"us-gov-east-1a",
			"us-gov-east-1b",
			"us-gov-east-1c"
		]
	},
];

export default REGION_LIST.filter(region => ENABLED_REGIONS.has(region.code));
